import { queryFactory, queryWithVariablesFactory } from "./useQuery";
export var useProductDetails = queryWithVariablesFactory("getProductDetails"); // export const useProductList = queryWithVariablesFactory("getProductList");

export var useShopDetails = queryFactory("getShopDetails");
export var useUserDetails = queryFactory("getUserDetails");
export var useOrderDetails = queryWithVariablesFactory("getOrderDetails");
export var useOrdersByUser = queryWithVariablesFactory("getOrdersByUser"); // export const useCategoryDetails = queryWithVariablesFactory(
//  "getCategoryDetails"
// );
// export const useAtrributes = queryWithVariablesFactory("getAttributes");
// export const useVariantsProducts = queryWithVariablesFactory(
//  "getVariantsProducts"
// );

export var useUserWishlist = queryWithVariablesFactory("getUserWishlist");